import { IconButton, IconButtonProps } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface CloseButtonProps extends IconButtonProps {
  onClose: () => void;
}

export const CloseButton = ({ onClose, ...props }: CloseButtonProps) => {
  return (
    <IconButton
      onClick={onClose}
      sx={{ 
        minWidth: 0, 
        p: 0, 
        color: 'grey.700',
        backgroundColor: 'transparent',
        '&:hover': { 
          backgroundColor: 'transparent',
          color: 'grey.900'
        }
      }}
      {...props}
    >
      <CloseIcon />
    </IconButton>
  );
}; 